import { t } from '@lingui/macro';
import { number, object, ref } from 'yup';
export const validationSchema = object().shape({
    from: number().required(t({
        message: 'Please provide a value',
        comment: 'Generic validation message when no data is provided for document metadata field',
    })),
    to: number().min(ref('from'), t({
        message: 'Must be greater than `From`',
        comment: 'Number range filter: `To` must be greater than `From` error message',
    })),
});
